export const tokens = {
    list: {
        gap: 10,
    },
    item: {
        minWidth: {
            mobile: 160,
            tablet: 240,
        },
    },
};
